

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TransactionDetailLogo from '@/components/TransactionDetailLogo.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import CommonApi from '@/app/api/CommonApi';
import { namespace } from 'vuex-class';

const I18nModule = namespace('i18n');

@Component({
  components: { NewTranslation, TransactionDetailLogo },
})
export default class TransactionDetailPage extends Vue {
  @Prop(String)
  appName!: string;

  @Prop(String)
  communeTitle!: string;

  @Prop(String)
  acceptingCommune!: string;

  @Prop(String)
  communeCssLogo!: string;

  @Prop(String)
  communeImageLogo!: string;

  @Prop(Number)
  taxcardCommuneId!: number;

  @I18nModule.Getter
  private readonly locale!: string;

  public taxcardCommuneTranslations: any;

  public async created() {
    await this.getSpecificCommuneTranslation();
  }

  public getTaxcardTranslation(textId:string): string {
    if (this.taxcardCommuneTranslations) {
      return this.taxcardCommuneTranslations[textId];
    }
    return '';
  }

  private isDefaultLogo():boolean {
    if (this.communeImageLogo != '' && this.communeImageLogo != null) {
      return false;
    }
    return true;
  }

  private getCommuneImageData():string {
    if (this.isDefaultLogo()) {
      return '';
    }
    return this.communeImageLogo
  }

  @Watch('locale')
  private async onLocaleChange(locale: string): Promise<void> {
    await this.getSpecificCommuneTranslation();
  }

  private async getSpecificCommuneTranslation() {
    if (this.taxcardCommuneId) {
      await CommonApi.getWalletTranslationMessages(this.taxcardCommuneId, this.locale).then((data) =>  {
        this.taxcardCommuneTranslations = data;
      });
    }
  }
}
